import { useEffect, useMemo } from 'react';

import { choreographerFactory, ProductIds } from '@atlassian/ipm-choreographer';

import { useAnalyticsEnvironment } from './useAnalyticsEnvironment';

export const useChoreographerServices = () => {
	const environment = useAnalyticsEnvironment();
	const choreographerServices = useMemo(() => {
		if (environment) {
			return choreographerFactory(ProductIds.CONFLUENCE, environment);
		}
	}, [environment]);
	const { plugin } = choreographerServices ?? {};

	useEffect(() => {
		/**
		 * Cleanup function in case we unmount this component to remount another one.
		 */
		return () => {
			if (plugin) {
				plugin.destroy();
			}
		};
	}, [plugin]);

	return choreographerServices;
};
